import { useParams } from "react-router-dom";
import { EditableWorkspaceCards } from "../cards/EditableWorkspaceCards";
import { useFusaOrganizationStore } from "@/frontend/store/FusaOrganizationStore";
import { useShallow } from "zustand/react/shallow";
import { NotFound } from "@/frontend/pages/NotFound";

// The organization's requirements and project templates live in the Library
// (/library), not here.
export function FusaOrganizationPage() {
  const fusaOrganizationId = useParams().fusaOrganizationId;
  const fusaOrganization = useFusaOrganizationStore(useShallow(state => state.fusaOrganizations.find(fusaOrganization => fusaOrganization.id === fusaOrganizationId)));

  if(!fusaOrganizationId || !fusaOrganization) {
    return <NotFound />;
  }

  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className="pb-3">
        <h1>{fusaOrganization.title}</h1>
        {fusaOrganization.description && (
          <p className="text-muted">{fusaOrganization.description}</p>
        )}
      </div>

      <EditableWorkspaceCards fusaOrganizationId={fusaOrganizationId} />
    </div>
  );
}
